import {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {useMsal} from '@azure/msal-react'
import useTabHighlightNotification from '../hooks/useTabHighlightNotification'
import TimeoutConfig from '../../appConfig/sessionTimeout.config.json'
import DialogContent from '@mui/material/DialogContent'
import {useTheme} from '@mui/material/styles'
import {StyledDiv, StyledDialog, StyledErrorIcon} from './SessionTimeoutNotificationStyle'

const SessionTimeoutNotificationComponent = ({isOpen, setTimeOutInactive}) => {
  const theme = useTheme()
  const {instance} = useMsal()
  const [countDown, setCountDown] = useState(0)
  const [countDownDisplay, setCountDownDisplay] = useState('')
  const intervalRef = useRef(null)
  const [setTabNotification, clearTabNotification] = useTabHighlightNotification()

  useEffect(() => {
    if (isOpen) {
      setTimerDisplay(TimeoutConfig.APP_NOTIFICATION_TIMEOUT_MINUTES, TimeoutConfig.APP_NOTIFICATION_TIMEOUT_SECONDS)
      startCountDown(TimeoutConfig.APP_NOTIFICATION_TIMEOUT_MINUTES, TimeoutConfig.APP_NOTIFICATION_TIMEOUT_SECONDS)
    }

    return () => {
      stopCountDown()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  useEffect(() => {
    if (isOpen && countDown <= 0) handleLogout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countDown])

  function startCountDown(minutes, seconds) {
    setTabNotification()
    const interval = setInterval(() => {
      if (seconds > 0) {
        seconds = seconds - 1
      }
      if (seconds === 0) {
        if (minutes !== 0) {
          minutes = minutes - 1
          seconds = 59
        }
      }
      setCountDown(minutes + seconds * 1000)
      setTimerDisplay(minutes, seconds)
    }, 1000)
    intervalRef.current = interval
  }

  function setTimerDisplay(minutes, seconds) {
    const displaySeconds = ('' + seconds)?.length > 1 ? seconds : '0' + seconds
    const displayMinutes = ('' + minutes)?.length > 1 ? minutes : '0' + minutes
    const displayTime = displayMinutes + ':' + displaySeconds
    setCountDownDisplay(displayTime)
  }

  function stopCountDown() {
    clearTabNotification()
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  function handleLogout() {
    handleCleanUp()
    sessionStorage.clear()
    instance.logout().catch((e) => {
      console.error(e)
    })
  }

  function handleContinue() {
    handleCleanUp()
  }

  function handleCleanUp() {
    stopCountDown()
    setTimeOutInactive()
  }

  if (!isOpen) return null

  const alertText = (
    <div>
      <StyledErrorIcon />
      <StyledDiv>
        Your session is about to end due to inactivity in {countDownDisplay} mins. If you&apos;d like to stay signed in,{' '}
        <button
          type='button'
          aria-label='click-to-continue-your-session'
          onClick={(event) => {
            event.preventDefault()
            handleContinue()
          }}
          style={{
            background: 'none',
            border: 'none',
            color: theme.palette.primary.dark,
            textDecoration: 'underline',
            cursor: 'pointer',
            padding: 0,
            font: 'inherit'
          }}
        >
          click here to continue
        </button>
      </StyledDiv>
    </div>
  )

  return (
    <StyledDialog
      PaperProps={{
        sx: {
          textAlign: 'center',
          marginTop: '0px',
          border: `1px solid ${theme.palette.error.main}`,
          borderRadius: '8px',
          background: theme.palette.error.light,
          width: 'fit-content'
        }
      }}
      fullWidth
      maxWidth='md'
      open={isOpen}
      aria-labelledby='session-timeout-dialog'
      aria-describedby='alert-dialog-description'
    >
      <DialogContent tabIndex={0} id='alert-dialog-description'>
        {alertText}
      </DialogContent>
    </StyledDialog>
  )
}

SessionTimeoutNotificationComponent.propTypes = {
  isOpen: PropTypes.bool,
  setTimeOutInactive: PropTypes.func
}
export default SessionTimeoutNotificationComponent
